var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaxtonlogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.365,
    height: 41.306,
    viewBox: "0 0 145.365 41.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paxton_logo_-_White",
    "data-name": "Paxton logo - White",
    transform: "translate(-116.898 -270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M23.915,41.319,11.988,20.665.066.013H47.76L35.837,20.665,23.915,41.319Z",
    transform: "translate(116.832 269.987)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10389",
    "data-name": "Path 10389",
    d: "M733.173,150.324a36.1,36.1,0,0,1,5.981-.466c3.08,0,5.336.716,6.769,2.006a6.491,6.491,0,0,1,2.113,5.049,7.107,7.107,0,0,1-1.862,5.157c-1.648,1.754-4.333,2.65-7.378,2.65a10.727,10.727,0,0,1-2.507-.214v9.669h-3.115Zm3.115,11.64a10.452,10.452,0,0,0,2.579.25c3.76,0,6.052-1.827,6.052-5.156,0-3.188-2.256-4.728-5.694-4.728a13.076,13.076,0,0,0-2.937.251Z",
    transform: "translate(-569.294 130.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10390",
    "data-name": "Path 10390",
    d: "M777.4,175.575a24.4,24.4,0,0,0,.287,4.154h-2.865l-.251-2.184h-.108a6.456,6.456,0,0,1-5.3,2.578,4.938,4.938,0,0,1-5.3-4.978c0-4.19,3.725-6.483,10.421-6.447v-.358c0-1.433-.394-4.011-3.939-4.011a8.633,8.633,0,0,0-4.512,1.289l-.716-2.077a10.76,10.76,0,0,1,5.694-1.54c5.3,0,6.59,3.617,6.59,7.091Zm-3.044-4.692c-3.438-.072-7.342.537-7.342,3.9a2.789,2.789,0,0,0,2.973,3.008,4.312,4.312,0,0,0,4.19-2.9,3.291,3.291,0,0,0,.179-1Z",
    transform: "translate(-583.33 124.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10391",
    "data-name": "Path 10391",
    d: "M797.69,162.727l2.471,3.724c.644.968,1.182,1.862,1.754,2.829h.108c.573-1.039,1.146-1.934,1.719-2.865l2.435-3.689h3.4l-5.909,8.38,6.088,8.953h-3.581l-2.543-3.9c-.681-1-1.254-1.97-1.862-3.009H801.7c-.573,1.074-1.181,1.97-1.826,3.009l-2.507,3.9h-3.474l6.16-8.846-5.873-8.488Z",
    transform: "translate(-597.064 124.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10392",
    "data-name": "Path 10392",
    d: "M831.734,155.072v4.154h4.512v2.4h-4.512v9.347c0,2.148.609,3.366,2.364,3.366a5.9,5.9,0,0,0,1.826-.214l.143,2.363a7.591,7.591,0,0,1-2.793.466,4.385,4.385,0,0,1-3.4-1.361c-.9-.931-1.218-2.471-1.218-4.512v-9.455h-2.686v-2.4h2.686v-3.187Z",
    transform: "translate(-611.732 127.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    "data-name": "Path 10393",
    d: "M865.677,170.919c0,6.41-4.441,9.2-8.63,9.2-4.691,0-8.309-3.438-8.309-8.918,0-5.8,3.8-9.2,8.595-9.2C862.311,162,865.677,165.618,865.677,170.919Zm-13.752.179c0,3.8,2.185,6.661,5.264,6.661,3.009,0,5.265-2.829,5.265-6.732,0-2.937-1.468-6.662-5.193-6.662S851.925,167.8,851.925,171.1Z",
    transform: "translate(-622.146 124.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10394",
    "data-name": "Path 10394",
    d: "M887.161,167.087c0-1.791-.036-3.259-.143-4.692h2.793l.179,2.865h.072a6.374,6.374,0,0,1,5.73-3.259c2.4,0,6.124,1.433,6.124,7.377v10.35h-3.151v-9.992c0-2.794-1.039-5.122-4.011-5.122a4.479,4.479,0,0,0-4.226,3.223,4.548,4.548,0,0,0-.214,1.468v10.422h-3.152Z",
    transform: "translate(-639.653 124.794)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxtonlogoWhite);
export default __webpack_public_path__ + "static/media/Paxton logo - White.6123e4af2bd18df717647a474415c8eb.svg";
export { ForwardRef as ReactComponent };